<script lang="ts">
  import { icons } from './icons';

  interface Props {
    name: string;
    width?: string;
    height?: string;
    colour?: string;
    class?: string;
  }

  let {
    name,
    width = '100%',
    height = '100%',
    colour = 'white',
    class: clazz = '',
  }: Props = $props();

  function parseIcon(icon: string) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(icon, 'image/svg+xml');

    const displayIcon = doc.documentElement;
    displayIcon.setAttribute('width', width);
    displayIcon.setAttribute('height', height);

    displayIcon.setAttribute('fill', colour);
    // displayIcon.style.fill = colour;
    // displayIcon.style['z-index'] = 1;

    displayIcon.classList.add('icon');
    if (clazz) {
      clazz.split(' ').forEach((c: string) => {
        if (c) {
          displayIcon.classList.add(c);
        }
      });
    }

    return displayIcon.outerHTML;
  }

  let displayIconString = $derived.by(() => {
    const selectedIcon = icons[name !== '' ? name : 'blank']?.icon;
    if (!selectedIcon) {
      if (name !== '') {
        console.error('No icon for:', name);
      }
      return '';
    }
    return parseIcon(selectedIcon);
  });
</script>

<!-- width={width} -->
<!-- height={height} -->
<!-- <svg
  class={$$props.class}
  style="
    width: {width != '100%'? width : 'var(--icon-size)'};
    height: {height != '100%'? height : 'var(--icon-size)'};
    fill: {colour}"
  viewBox="0 0 500 500">{@html displayIcon.svg}</svg> -->

{@html displayIconString}

<style lang="less">
  :global(.icon) {
    stroke: black;
    stroke-width: 10px;
    z-index: 1;

    width: var(--icon-size);
    height: var(--icon-size);
  }
</style>
